<p-dialog [(visible)]="showUnrejectDialog" [modal]="true">
  <ng-template #header>
    Unrejection Reason
  </ng-template>
  <div class="overlay" *ngIf="loading">
    <div class="spinner-wrapper">
      <app-spinner>
        <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
      </app-spinner>
    </div>
  </div>
  <div style="height: 100px;">
    <label>Comment:</label><br />
    <textarea [(ngModel)]="unrejectionDescription" size="30" [style]="{'width':'400px'}"></textarea>
  </div>
  <ng-template #footer>
    <button (click)="close(false)" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-times"></i> Cancel
    </button>
    <button (click)="unReject()" class="float-right" style="margin-right:10px;margin-left:10px">
      <i class="fa fa-save"></i> Unreject
    </button>
  </ng-template>
</p-dialog>
